/**
 * @Time    : 2024/1/12 15:42
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { history, useIntl } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const UnAccessiblePage: React.FC = () => (
  <Result
    status="403"
    title="403"
    subTitle={useIntl().formatMessage({
      id: 'pages.403.subTitle',
      defaultMessage: 'Sorry, you are not authorized to access this page.',
    })}
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        {useIntl().formatMessage({ id: 'pages.403.buttonText', defaultMessage: 'Back Home' })}
      </Button>
    }
  />
);

export default UnAccessiblePage;
